$bog_smalljs_search $mol_view
	open? false
	query? \
	anchor_key \
	close? null
	focus? null
	activate? null
	select_next? null
	select_prev? null
	pick*? null
	attr *
		bog_smalljs_search_open <= open
	plugins /$mol_plugin
		<= Escape $mol_hotkey
			key * escape? <=> close?
		<= Nav_down $mol_hotkey
			key * down? <=> select_next?
		<= Nav_up $mol_hotkey
			key * up? <=> select_prev?
	sub /
		<= Backdrop $mol_view
			event *
				click? <=> close?
		<= Panel $mol_view
			sub /
				<= Field $mol_string
					value? <=> query?
					hint @ \Search the documentation…
					submit? <=> activate?
				<= Hint $mol_view
					sub / <= hint_text
				<= Results $mol_list
					rows <= result_rows /
	Result* $mol_link
		arg <= result_arg* *
		event_click? <=> pick*?
		attr *
			^
			bog_smalljs_search_current <= result_current* false
		sub /
			<= Result_title* $mol_view
				sub / <= result_title* \
			<= Result_snippet* $mol_view
				sub / <= result_snippet* \
